import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import productBatch from './productBatch.vue';

var BatchAttributePage = function (_super) {
  __extends(BatchAttributePage, _super);

  function BatchAttributePage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.tabs = [];
    _this.tabList = [{
      value: 'product-batch',
      text: _this.t('生产批次'),
      dataSign: 'batch_attribute_tab_production',
      showAttr: 'pc_production'
    }];
    _this.activeTab = '';
    return _this;
  }

  BatchAttributePage.prototype.getTabListFilter = function () {
    var _this = this;

    this.tabs = this.tabList.filter(function (item) {
      if (!item.showAttr) {
        return true;
      }

      return !!_this.customerInfo[item.showAttr];
    });
  };

  BatchAttributePage.prototype.created = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.home.queryCustomerInfo({
              loading: false,
              hideAllError: true
            })];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? {} : _a;
            this.customerInfo = data;
            this.getTabListFilter();

            if (!this.activeTab && this.tabs.length) {
              this.activeTab = this.tabs[0].value;
            }

            return [2];
        }
      });
    });
  };

  BatchAttributePage = __decorate([Component({
    components: {
      productBatch: productBatch
    }
  })], BatchAttributePage);
  return BatchAttributePage;
}(Vue);

export default BatchAttributePage;